<section
  [formGroup]="fieldForm"
  class="series"
  *ngIf="currentDataFields && currentDataFields.length > 0 && chartType"
>
  <span class="sectionHeader">SERIES* </span>

  <div class="fieldArea">
    <div class="seriesLine"></div>
    <div class="selectFilter" [formGroup]="fieldForm">
      <div class="left">
        <mat-form-field appearance="fill" style="width: 100%">
          <mat-select
            class="filterSelect"
            formControlName="selectItem"
            [placeholder]="choosePlaceholder()"
            floatPlaceholder="never"
            (selectionChange)="addSeries()"
            [disabled]="seriesSelectDisabled()"
          >
            <mat-option
              *ngFor="let item of currentDataFields"
              [value]="item.id"
            >
              {{ item.name }}
            </mat-option>
          </mat-select>
          <fa-icon
            [icon]="faTriangleExclamation"
            matSuffix
            mat-button
            *ngIf="showSeriesAlert"
            class="SeriesAlert"
            matTooltip="This chart exceeds the 15 series limit and is missing information - consider removing one or more series or adding filters"
          ></fa-icon>
        </mat-form-field>
      </div>
    </div>
    <div
      cdkDropList
      (cdkDropListDropped)="drop($event)"
      class="reportField-list"
    >
      <div
        cdkDragBoundary=".reportField-list"
        class="reportField-box"
        *ngFor="let reportField of seriesFields; let i = index"
        cdkDrag
      >
        <div class="reorder-placeholder" *cdkDragPlaceholder></div>
        <div class="canvasFields">
          <div
            id="seriesRight-{{ i }}"
            [ngClass]="{ selected: selectedIndex == i }"
          >
            <div class="far-left">
              <fa-icon [icon]="faGripDotsVertical" class="grip"></fa-icon>
            </div>
            <div class="left"></div>
            <div
              class="right"
              matTooltip="{{
                reportField.name || reportField.dataPoint.data.name
              }}"
              matTooltipPosition="above"
              (click)="configureSeries($event, i, reportField)"
            >
              <div class="title">
                {{ reportField.name || reportField.dataPoint.data.name }}
              </div>
              <div class="type">
                {{
                  getbreakDownDataPointIdName(reportField.breakDownDataPointId)
                }}
              </div>
            </div>
            <div class="far-right">
              <fa-icon
                [icon]="faEdit"
                (click)="configureSeries($event, i, reportField)"
                matTooltip="Configure this series"
                matTooltipPosition="above"
                *ngIf="chartType != 'Pie'"
              ></fa-icon>
              <fa-icon
                [icon]="faTrash"
                (click)="removeDataField($event, i)"
              ></fa-icon>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
